import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Skeleton } from "@material-ui/lab";

export const ShopGridSkeleton = React.memo(function ShopGridSkeleton() {
  return (
    <Row xs={1} md={2} xl={3} xxl={4}>
      {Array.from({ length: 5 }).map((_, idx) => (
        <Col key={idx} className="p-4">
          <Card>
            <Skeleton variant="rect" height={350} />
          </Card>
        </Col>
      ))}
    </Row>
  );
});
